export default "__VITE_ASSET__B87Yh0JZ__"